import { Tooltip } from '@mui/material';

// function for show menu selected
export const menuItems = {
  pnl: ['/pnl-dashboard', '/pnl-item', '/pnl-by-category', '/parent-sku', '/group-by-pnl'],
  ppc: ['/dashboard', '/ppc-item', '/ppc-category', '/group-by-ppc', '/ppc-by-parent'],
  sales: ['/sales-dashboard', '/sales-item', '/sales-category', '/group-by-sales', '/sales-by-parent'],
  items: ['/cogs-list', '/pnl-tags'],
  keywordtrackingmenu: ['/keyword-tracking']
};

export const parentMenuByChild = (child) => {
  for (const category in menuItems) {
    if (menuItems[category].includes(child)) {
      return category;
    }
  }
  return null;
};

// function for truncate the product name
export const productTruncate = (product) => {
  const maxLength = 80;
  return product && product?.length > maxLength ? product && product?.substring(0, maxLength) + '...' : product;
};

export const arrayMove = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export const removeElementFromArray = (array, ItemValue) => {
  const index = array.indexOf(ItemValue);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};

export const arrayMoveByValue = (arr, itemValue1, itemValue2) => {
  const new_index = arr.indexOf(itemValue1);
  const old_index = arr.indexOf(itemValue2);
  if (new_index && old_index && new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const showValues = (data, lists) => {
  const dispValue = `${data?.length} of ${lists?.length} selected`;
  return (
    <Tooltip title={dispValue}>
      <span className="dorpdown-text-trim">{dispValue}</span>
    </Tooltip>
  );
};
export const requestWithTagFilter = (request) => {
  let localTags = localStorage.getItem('tagFilter');
  let selected = [];
  if (localTags) {
    selected = JSON.parse(localTags);
  }

  if (selected?.length) {
    Object.assign(request, { tag_ids: selected?.map((v) => v?.id) });
  } else {
    delete request['tag_ids'];
  }

  let localSoldByFilter = localStorage.getItem('soldByFilter');
  let selectedSoldBy = [];
  if (localSoldByFilter) {
    selectedSoldBy = JSON.parse(localSoldByFilter);
  }

  if (selectedSoldBy?.length) {
    Object.assign(request, { sold_by: selectedSoldBy?.map((v) => v?.store_name) });
  } else {
    delete request['sold_by'];
  }
  return request;
};

export const validateEmail = (email) => {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (email?.match(validRegex)) {
    return true;
  } else {
    return false;
  }
};

export const formatDate = (date) => {
  if (!date) return null;

  const d = new Date(date);

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate()
  ).padStart(2, '0')}`;
};

export const getDateDiffInDays = (currentDate, scrapedDate) => {
  if (!currentDate || !scrapedDate) return null;

  const d1 = new Date(currentDate);
  const d2 = new Date(scrapedDate);

  const diffTime = d1.getTime() - d2.getTime();
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};